import React, { useState, useEffect } from 'react';
import api from '../../api/axios';
import { format } from 'date-fns';
import { toast } from 'react-toastify';

const DOC_TYPES = ['BL Copy','LC Copy','Commercial Invoice','Packing List','Customs / Shipping Bill','Bank Documents','Other'];

export default function AttachmentsPanel({ orderId }) {
  const [attachments, setAttachments] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [form, setForm] = useState({ doc_type:'', remarks:'' });
  const [file, setFile] = useState(null);

  const load = () => api.get(`/attachments/order/${orderId}`).then(r => setAttachments(r.data));
  useEffect(() => { load(); }, [orderId]);

  const upload = async e => {
    e.preventDefault();
    if (!file) { toast.error('Please select a file'); return; }
    const fd = new FormData();
    fd.append('file', file);
    fd.append('doc_type', form.doc_type);
    fd.append('remarks', form.remarks);
    setUploading(true);
    try { await api.post(`/attachments/order/${orderId}`, fd, { headers:{'Content-Type':'multipart/form-data'} }); toast.success('File uploaded'); load(); setFile(null); setForm({doc_type:'',remarks:''}); }
    catch(err) { toast.error(err.response?.data?.message || 'Upload failed'); }
    finally { setUploading(false); }
  };

  const del = async (id) => {
    if (!window.confirm('Delete this attachment?')) return;
    try { await api.delete(`/attachments/${id}`); toast.success('Deleted'); load(); }
    catch { toast.error('Delete failed'); }
  };

  return (
    <div>
      <div className="card mb-2">
        <div className="section-title">Upload Document</div>
        <form onSubmit={upload}>
          <div className="form-row-3">
            <div className="form-group">
              <label>Document Type</label>
              <select className="form-control" value={form.doc_type} onChange={e=>setForm({...form,doc_type:e.target.value})}>
                <option value="">— Select Type —</option>
                {DOC_TYPES.map(t=><option key={t}>{t}</option>)}
              </select>
            </div>
            <div className="form-group"><label>File (PDF/JPG/PNG/TIFF)</label><input className="form-control" type="file" accept=".pdf,.jpg,.jpeg,.png,.tiff,.tif" onChange={e=>setFile(e.target.files[0])} /></div>
            <div className="form-group"><label>Remarks</label><input className="form-control" value={form.remarks} onChange={e=>setForm({...form,remarks:e.target.value})} /></div>
          </div>
          <button className="btn btn-primary btn-sm" type="submit" disabled={uploading}>{uploading?'Uploading...':'Upload'}</button>
        </form>
      </div>

      <div className="card" style={{padding:0}}>
        <div style={{padding:'14px 16px',borderBottom:'1px solid var(--border)'}}><b>Attached Documents ({attachments.length})</b></div>
        {attachments.length === 0 ? <div className="empty-state">No documents attached</div> :
          <div className="table-wrap">
            <table>
              <thead><tr><th>Type</th><th>File Name</th><th>Uploaded By</th><th>Date</th><th>Remarks</th><th></th></tr></thead>
              <tbody>
                {attachments.map(a => (
                  <tr key={a.id}>
                    <td><span className="badge badge-blue">{a.doc_type||'—'}</span></td>
                    <td><a href={a.file_path} target="_blank" rel="noreferrer" style={{color:'var(--primary)'}}>{a.original_filename}</a></td>
                    <td>{a.uploaded_by_name}</td>
                    <td>{format(new Date(a.created_at),'dd/MM/yyyy')}</td>
                    <td className="text-muted">{a.remarks||'—'}</td>
                    <td><button className="btn btn-danger btn-xs" onClick={()=>del(a.id)}>Delete</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        }
      </div>
    </div>
  );
}
